// src/modules/clinical-note-ai/components/PdfUploadCard.jsx

import React, { useRef } from 'react';
import { Card, CardContent, Stack, Typography, Button } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';

const PdfUploadCard = ({ file, onChange }) => {
  const inputRef = useRef(null);

  const handlePick = () => inputRef.current?.click();

  const handleFile = (f) => {
    if (!f) return;
    if (f.type !== 'application/pdf') {
      alert('Only PDF files are allowed');
      return;
    }
    onChange?.(f);
  };

  return (
    <Card variant="outlined" sx={{ borderRadius: 3 }}>
      <CardContent>
        <Stack spacing={1}>
          <Typography variant="subtitle2" fontWeight={700}>
            Select a PDF file
          </Typography>

          <Stack direction="row" spacing={1} alignItems="center">
            <Button startIcon={<UploadFileIcon />} variant="outlined" onClick={handlePick}>
              Choose PDF
            </Button>

            <input
              ref={inputRef}
              type="file"
              accept="application/pdf"
              style={{ display: 'none' }}
              onChange={(e) => handleFile(e.target.files?.[0])}
            />
          </Stack>

          <Typography variant="body2" sx={{ mt: 1 }}>
            {file ? (
              <>
                <strong>Selected:</strong> {file.name} ({Math.round(file.size / 1024)} KB)
              </>
            ) : (
              'No file selected.'
            )}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default PdfUploadCard;
